import { Navigate } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import LegacySystemSettings from "./LegacySystemSettings";
import WellnessSettings from "./WellnessSettings";
import IntegrationSettings from "./IntegrationSettings";
import SessionReload from "./component-assets/SessionReload";
import EnvironmentSettings from "./EnvironmentSettings";
import {compareRole, iAmHigherAuthority} from "../libs";
import LightCtrlSettings from "./LightCtrlSettings";
import SystemSettings from "./SystemSettings";
import PalPendantSettings from "./PalPendantSettings";
import Careflow from "./Careflow";
import TestPage from "./TestPage";
import StringBuilder from "./StringBuilder";

const Settings = (props) => {
    let settingsContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);

        dData = JSON.parse(bData.toString(enc.Utf8));
    }
    if (paramVars.dType === "system" && (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight))){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            settingsContent = <SystemSettings />;
        }else{
            settingsContent = <LegacySystemSettings />;
        }
    }else if (paramVars.dType === "wellness" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <WellnessSettings />;
    }else if (paramVars.dType === "careflow" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <Careflow />;
    }else if (paramVars.dType === "test" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <TestPage />;
    }else if (paramVars.dType === "text_builder" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <StringBuilder />;
    }else if (paramVars.dType === "environmental" && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <EnvironmentSettings />;
    }else if (paramVars.dType === "lightctrl" && iAmHigherAuthority(80, dData.role_weight)){
        settingsContent = <LightCtrlSettings />;
    }else if (paramVars.dType === "palpendant" && dData?.campusData[dData?.acnt.toString()]?.is_cloud && iAmHigherAuthority(20, dData.role_weight)){
        settingsContent = <PalPendantSettings />;
    }
    else{
        settingsContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (compareRole("admin", dData?.userrole) || iAmHigherAuthority(20, dData.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {settingsContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Settings;